export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00159.cc838f80.png";